import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

import { Typography } from '@/shared/components/atoms';

import DocumentIcon from '~/images/shared/Document.svg';
import TrashIcon from '~/images/shared/TrashWithoutColor.svg';

const FileCard: React.FC<{
  name: string;
  size: number;
  error?: string;
  handleRemove: () => void;
}> = ({ name, size, handleRemove, error }) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(
        ' rounded-lg border-xs p-16',
        error
          ? 'border-error-350 bg-error-95'
          : 'border-outline-variant bg-background-neutral-99'
      )}
    >
      <div className='flex justify-between'>
        <div className='flex gap-8'>
          <div
            className={classNames(
              'flex h-[28px] w-[28px] items-center justify-center rounded-full',
              error
                ? 'bg-error-90 text-error-400'
                : 'bg-surface-20 text-primary-default'
            )}
          >
            <DocumentIcon />
          </div>
          <div>
            {error && (
              <Typography variant='subtitle2' className='mb-2 text-error-20'>
                {t(error)}
              </Typography>
            )}
            <Typography
              weight='medium'
              variant='subtitle2'
              className={classNames('mb-2', error && 'text-error-400')}
            >
              {name}
            </Typography>
            {!error && (
              <Typography className='text-surface-10' variant='subtitle2'>
                {`${size / 1000} KB`}
              </Typography>
            )}
          </div>
        </div>
        <div
          className={classNames(
            'cursor-pointer px-2',
            error ? 'text-error-400' : 'text-primary-default'
          )}
          onClick={handleRemove}
        >
          <TrashIcon width='24' height='24' />
        </div>
      </div>
    </div>
  );
};

export default FileCard;
